export default __webpack_public_path__ + "static/media/icons-scope.de0d23fc.svg";